import { queries } from 'RestAPIs/rapini';

import type { ActivityResponse, SchedulingLabel } from 'generated/index';

/**
 * The MRP activities, as the overview lists MRP appointments (the list includes the activities with a VV
 * label). The label is required: without one the backend has nothing to select on and fails. It expects a
 * comma separated string rather than an array. One cached list for the field and the applied chips alike.
 */
export const useMrpActivities = (): ActivityResponse[] => {
  const { data = [] } = queries.useGetActivities(
    'MRP' as unknown as SchedulingLabel[],
    undefined,
    undefined,
    { staleTime: Infinity }
  );
  return data;
};
